import { BitfStrapiModel } from '@common/libs/bitforce/core/models';
import { Contract } from './contract.model';
import { Company } from './company.model';

export class Convention extends BitfStrapiModel {
  nameAqConvention: string;
  conventionId: string;
  seller: string;
  conventionActivationDate: Date;
  conventionDurationInMonths: number;
  renewalDurationInMonths: number;
  contracts: Contract[];
  company: Company;

  constructor(data: Partial<Convention> = {}) {
    super({ data });
    if (data.conventionActivationDate) {
      this.conventionActivationDate = new Date(data.conventionActivationDate);
    }
    if (data.contracts) {
      this.contracts = data.contracts.map(contract => new Contract(contract));
    }

    if (data.company) {
      this.company = new Company(data.company);
    }
  }

  get serialised() {
    return {
      id: this.id,
      documentId: this.documentId,
      nameAqConvention: this.nameAqConvention,
      contracts: this.contracts.map(contract => contract.serialised),
      conventionId: this.conventionId,
      seller: this.seller,
      conventionActivationDate: this.conventionActivationDate,
      conventionDurationInMonths: this.conventionDurationInMonths,
      renewalDurationInMonths: this.renewalDurationInMonths,
    };
  }
}
